import { createContext } from 'react';
import { TRestaurantFullInfoVisibleForm } from '../../RestaurantFullInfo/restaurantFullInfoState/restaurantFullInfoContext';
import { IRestaurants, TTypeOfServiceProvided, EntityStatus } from 'types';

export type TRestaurantsSortBy =
	| ''
	| 'NameA-Z'
	| 'NameZ-A'
	| 'CustomerA-Z'
	| 'CustomerZ-A'
	| 'CityA-Z'
	| 'CityZ-A'
	| 'CountryA-Z'
	| 'CountryZ-A';
export type TRestaurantsCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'toConfirmArchiveItem'
	| 'toConfirmRestoreItem'
	| 'success'
	| 'error'
	| 'errorActivatedDevices'
	| 'archiveSuccess'
	| 'archiveError'
	| 'restoreSuccess'
	| 'restoreError';
export interface IFullInfoData {
	id: string;
	activeTab?: TRestaurantFullInfoVisibleForm;
}
export interface IFilterValues {
	searchString: string;
	IDSelectedCountry: Nullable<string>;
	IDSelectedCity: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	IDsSelectedClientType: TTypeOfServiceProvided[];
	status: EntityStatus;
	sortBy: TRestaurantsSortBy;
	countOfItems: TRestaurantsCountOfItems;
	currentPage: number;
}

export interface IRestaurantsState {
	restaurants: IRestaurants;
	searchString: string;
	IDSelectedCountry: Nullable<string>;
	IDSelectedCity: Nullable<string>;
	IDSelectedCustomer: Nullable<string>;
	IDsSelectedClientType: TTypeOfServiceProvided[];
	status: EntityStatus;
	sortBy: TRestaurantsSortBy;
	countOfItems: TRestaurantsCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForArchiving: string;
	IDForRestoring: string;
	fullInfoData: IFullInfoData;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const restaurantsInitialState: IRestaurantsState = {
	restaurants: { restaurantCount: 0, restaurants: [] },
	searchString: '',
	IDSelectedCountry: null,
	IDSelectedCity: null,
	IDSelectedCustomer: null,
	IDsSelectedClientType: [],
	status: EntityStatus.Active,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForArchiving: '',
	IDForRestoring: '',
	fullInfoData: {
		id: '',
	},
	typeOfModalWindow: null,
};

export interface IRestaurantsContext extends IRestaurantsState {
	deleteSelectedItem(): void;
	archiveSelectedItem(): void;
	restoreSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCountry(value: Nullable<string>): void;
	setIDCity(value: Nullable<string>): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDsClientType(value: TTypeOfServiceProvided[]): void;
	setStatus(value: EntityStatus): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TRestaurantsSortBy): void;
	setCountOfItems(count: TRestaurantsCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForArchiving(value: string): void;
	setIDForRestoring(value: string): void;
	setFullInfoData(value: string, activeTab?: TRestaurantFullInfoVisibleForm): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const RestaurantsContext = createContext<IRestaurantsContext>({
	deleteSelectedItem: async () => undefined,
	archiveSelectedItem: async () => undefined,
	restoreSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	setIDCountry: () => undefined,
	setIDCity: () => undefined,
	setIDCustomer: () => undefined,
	setIDsClientType: () => undefined,
	setStatus: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForArchiving: () => undefined,
	setIDForRestoring: () => undefined,
	setFullInfoData: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...restaurantsInitialState,
});
